// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function AdminDashboardHeaderMobile(Props) {
  let title = Props.title;
  let leftChildrenOpt = Props.leftChildren;
  let openMenu = Props.openMenu;
  let rightChildrenOpt = Props.rightChildren;
  let subheaderOpt = Props.subheader;
  let showMenuOpt = Props.showMenu;
  const leftChildren = leftChildrenOpt !== undefined ? Caml_option.valFromOption(leftChildrenOpt) : null;
  const rightChildren = rightChildrenOpt !== undefined ? Caml_option.valFromOption(rightChildrenOpt) : null;
  const subheader = subheaderOpt !== undefined ? Caml_option.valFromOption(subheaderOpt) : null;
  const showMenu = showMenuOpt !== undefined ? showMenuOpt : true;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              leftChildren,
              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                className: "text-white",
                children: title
              })
            ],
            className: "flex items-center gap-2"
          }),
          showMenu ? JsxRuntime.jsxs("div", {
              children: [
                rightChildren,
                JsxRuntime.jsx("div", {
                  className: "border-l border-asphalt-dark h-5"
                }),
                JsxRuntime.jsx("button", {
                  children: JsxRuntime.jsx("img", {
                    className: "w-6 h-6",
                    src: StaticAsset.src("/static/icons/menu-white-24.svg")
                  }),
                  onClick: openMenu
                })
              ],
              className: "flex items-center gap-2"
            }) : JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  className: "border-l border-asphalt-dark h-5"
                }),
                rightChildren
              ],
              className: "flex items-center gap-6"
            })
        ],
        className: "h-14 bg-black flex justify-between px-4"
      }),
      subheader
    ],
    className: "flex flex-col"
  });
}

const make = AdminDashboardHeaderMobile;

export {
  make,
}
/* Buhta_components__Text Not a pure module */
